<template>
  <!-- Design-system look of the sign-in pages: the night stage (Components/Auth/AuthShell.vue). -->
  <template v-if="designSystem && isAuthPage">
    <Head>
      <title>AirLST</title>
      <meta name="robots" content="noindex, nofollow" />
    </Head>
    <AuthShell :wide="WIDE_PAGES.includes(currentComponent)">
      <slot />
    </AuthShell>
  </template>

  <div
    v-else
    class="relative bg-white bg-cover bg-no-repeat subpixel-antialiased flex flex-col h-screen overflow-y-auto"
    :style="{
      'background-image': `url('${Vapor.asset('images/airlst-background-2025.jpg')}')`,
    }"
  >
    <Head v-if="showChrome">
      <title>AirLST</title>
      <meta name="robots" content="noindex, nofollow" />
    </Head>

    <AuthHeader v-if="showChrome" />

    <div class="relative flex-1 flex flex-col z-2">
      <main id="main-content" class="relative flex-1">
        <slot />
      </main>
      <Footer v-if="showChrome" />
    </div>
  </div>
</template>

<script setup>
import Footer from '@/Components/Footer.vue'
import AuthHeader from '@/Components/AuthHeader.vue'
import AuthShell from '@/Components/Auth/AuthShell.vue'
import { useDesignSystem } from '@/composables/designSystem'
import Vapor from 'laravel-vapor'
import { Head, usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

const component = usePage().component
const isAuth = component.includes('Auth/')
const isLegalPages = ['TermsOfUse', 'Imprint', 'PrivacyPolicy'].includes(
  component,
)
const isQuotaApproval = component === 'GuestGroups/QuotaApproval'
const showChrome = isAuth || isLegalPages || isQuotaApproval
const designSystem = useDesignSystem()

/**
 * The sign-in pages share this layout instance while one leads to the next (login to sign-up), so
 * the design-system shell reads the current page reactively.
 */
const page = usePage()
const currentComponent = computed(() => String(page.component ?? ''))
const isAuthPage = computed(() => currentComponent.value.startsWith('Auth/'))
/** The longer forms get a slightly wider card. */
const WIDE_PAGES = ['Auth/Register', 'Auth/Activate', 'Auth/OAuthRegister']
</script>
